/* import __COLOCATED_TEMPLATE__ from './errors-collection.hbs.js'; */
import Component from "@ember/component";
import { tagName } from "@ember-decorators/component";
const ErrorsCollection = dt7948.c(class ErrorsCollection extends Component {}, [tagName("")]);
export default ErrorsCollection;